import {COMPANY_KEYS} from "@/api/companyApi";
import {client} from "@/httpClient";
import type {TFloatingBuyouts} from "@/store/types";
import {useMutation} from "@tanstack/react-query";

const useAdditionalLimitRequest = ({companyId, type}: {companyId: number; type: TFloatingBuyouts}) => {
  const {isPending, mutateAsync} = useMutation({
    mutationKey: COMPANY_KEYS.mCompanyAdditionalLimitRequest(companyId),
    mutationFn: () =>
      client.post(COMPANY_KEYS.mCompanyAdditionalLimitRequest(companyId)[0], {limit_type: type.toUpperCase()}),
  });

  return {isPending, request: async () => await mutateAsync()};
};

export default useAdditionalLimitRequest;
